import { useTranslation } from 'react-i18next';
import eleve from "../../../img/symbols/eleve.svg";
import leger from "../../../img/symbols/leger.svg";
import faible from "../../../img/symbols/faible.svg";
import modere from "../../../img/symbols/modere.svg";
import tresEleve from "../../../img/symbols/tres-eleve.svg";

/**
 * RiskSymbolsLegends component displays the risk level symbols with their corresponding labels
 * @param {Object} props - Component props
 * @param {string} props.title - Optional custom title for the legend
 * @returns {JSX.Element} The risk symbols legend component
 */
const RiskSymbolsLegends = ({ title }) => {
    const { t } = useTranslation('common');

    const legend = [
        { label: t('legends.risk.low'), image: faible },
        { label: t('legends.risk.light'), image: leger },
        { label: t('legends.risk.moderate'), image: modere },
        { label: t('legends.risk.high'), image: eleve },
        { label: t('legends.risk.extremelyHigh'), image: tresEleve }
    ];

    const displayTitle = title || t('legends.title');

    return (
        <div className="flex gap-6 items-center flex-wrap">
            <p className="text-[#186845] text-[14px] font-bold">{displayTitle}</p>
            <div className="flex gap-4 flex-wrap">
                {legend.map((item, index) => (
                    <div key={index} className="flex flex-col gap-2 items-center">
                        <img src={item.image} alt={item.label} className="w-8 h-8" />
                        <span className="text-sm max-w-[90px] text-center">{item.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RiskSymbolsLegends;